import actions from './actions'

/**
 * Usage figures for the Usage panel. Only the raw counts come from the API; every
 * limit, percentage and date is computed in the saga from `app.parameters`.
 */
export interface AppUsageAndOverages {
  /** Present only on the zero-usage shape; the populated shape omits it. */
  mau?: number
  currentUsageUsers: number
  ccu: number
  voice_minutes: number
  video_minutes: number
  recorded_minutes: number
  mauLimit?: number
  ccuLimit?: number
  mcuLimit?: number
  dcuLimit?: number
  voice_minutes_limit?: number
  video_minutes_limit?: number
  /** Percentages (0-100+), used to fill the segmented meters. */
  currentUsageUsersUsed: number
  ccuUsed: number
  voiceMinutesUsed: number
  videoMinutesUsed: number
  mau_overage: number
  ccu_overage: number
  /** Human-formatted billing window, '' when there is no term. */
  fromDate: string
  toDate: string
}

export interface BillingState {
  subscribePlanOngoingData: unknown[]
  subscribePlanOngoingLink: string
  subscribePlanAppData: unknown[]
  subscribeTotalCharge: number
  subscribeDowngradeAtEOT: boolean
  appUsageAndOverages: AppUsageAndOverages | unknown[]
  fetchedInsightsData: unknown[]
  appUsageAndOveragesLoading: boolean
  billingInvoices: unknown[]
}

const initialState: BillingState = {
  subscribePlanOngoingData: [],
  subscribePlanOngoingLink: '',
  subscribePlanAppData: [],
  subscribeTotalCharge: 0,
  subscribeDowngradeAtEOT: true,
  // `[]` rather than an object is the legacy default the UI already tolerates.
  appUsageAndOverages: [],
  fetchedInsightsData: [],
  appUsageAndOveragesLoading: false,
  billingInvoices: [],
}

interface SetStateAction {
  type: string
  payload: Partial<BillingState>
}

export default function billingReducer(
  state: BillingState = initialState,
  action: SetStateAction,
): BillingState {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
